module.exports = __webpack_public_path__ + "img/Rolanda Hollis.7cb1fa1a.jpg";